/** @type {import('../help-index.js').HelpSidebarItem} */
export const ACC_CFG_MAPPINGS_ITEM = {
  id: 'mappings',
  screenId: 'acc-cfg-mappings',
  label: 'Mapeos de instrumentos',
  description: 'Cuenta contable por banco, caja y POS de tarjetas.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Cada caja, cuenta bancaria y terminal de tarjetas debe tener una cuenta del plan contable. El sistema la usa al generar asientos de cobros y pagos.',
      },
      {
        title: 'Tablas',
        bullets: [
          'Cuentas bancarias — transferencias, depósitos, QR.',
          'Cajas — efectivo. Si falta, se usa la cuenta default de caja.',
          'POS tarjetas de crédito — cobros con cupón.',
        ],
      },
      {
        title: 'Paso — Asignar cuenta',
        fields: [
          { label: 'Cuenta contable', description: 'Buscador del plan de cuentas por código o nombre.' },
        ],
        paragraphs: ['Tocá «Guardar» en cada fila. Sin mapeo, la generación de asientos de cobros/pagos puede fallar.'],
      },
    ],
  },
}
